import { render } from "./UserSetting.vue?vue&type=template&id=49e30e32&scoped=true"
import script from "./UserSetting.vue?vue&type=script&lang=js"
export * from "./UserSetting.vue?vue&type=script&lang=js"

import "./UserSetting.vue?vue&type=style&index=0&id=49e30e32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e30e32"]])

export default __exports__